import script from "./On.vue?vue&type=script&lang=ts&setup=true"
export * from "./On.vue?vue&type=script&lang=ts&setup=true"

import "./On.vue?vue&type=style&index=0&id=eaccf45e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eaccf45e"]])

export default __exports__